<template>
    <div class="task-back">
        <!--环图片-->
        <div class="img-box">
            <div class="prop-up"></div>
            <img src="@/assets/img/circle.png" class="circle" alt="">
        </div>
        <div>
            <!--题目-->
            <div class="subject">
                <div>请问该任务与你所处的环境是否匹配？</div>
            </div>
            <!--选项-->
            <div style="width:115px;margin:calc(0.073 * var(--body-height)) auto 0;">
                <el-radio-group v-model="taskAnswer">
                    <el-radio label="非常匹配"></el-radio>
                    <el-radio label="基本匹配"></el-radio>
                    <el-radio label="不匹配"></el-radio>
                </el-radio-group>
            </div>
            <!--题目跳转-->
            <div class="subject-jump">
                <span @click="prevClick" class="prev-btn"><i class="icon-left"></i> {{ $t('preQues') }}</span>
                <el-button @click="nextClick" :disabled="countNumber != 0" style="width:160px;" type="primary">下一页<i class="icon-right"></i> ({{ countNumber }}s)
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import api from '@/api'

export default {
    name: "task_evaluation_finished",
    data() {
        return {
            //自然题答案
            taskAnswer: '',
            timer: null,
            countNumber: 0
        }
    },
    computed: {
        ...mapGetters([
            'userId'
        ]),
    },
    mounted() {
        //计时器
        this.countdown()
        this.$store.commit('SET_ANSWER_PERCENT', 100)
    },
    methods: {

        /**
         * 上一题
         */
        prevClick() {
            this.$router.push('/task_evaluation')
        },

        /**
         * 下一题
         */
        nextClick() {
            if (this.taskAnswer === '') {
                this.$toast(this.$t('selectOne'));
                return;
            }
            //保存答案
            let completed = localStorage.getItem('taskCompleted')
            api.questionnaire.saveTaskEvaluation(this.userId, completed, this.taskAnswer).then(res => {
                // 跳转页面
                this.$router.push('/end')
            })
        },

        /**
         * 验证码倒计时
         */
        countdown() {
            let that = this;
            this.countNumber = 2;
            if (this.timer) {
                clearInterval(this.timer);
            }
            this.timer = setInterval(function () {
                if (that.countNumber === 0) {
                    clearInterval(this.timer);
                } else {
                    that.countNumber--;
                }
            }, 1000);
        }
    }
}
</script>


<style scoped lang="less">
.task-back {
    width: 100%;
    height: 100%;
    background-image: url("../../assets/img/ecoBack.png");
    background-size: cover;
}
</style>